import React from 'react'

export default function StarIcon({ size = 14, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.2714 4.86563L9.08036 4.22544L7.20182 0.224096C7.06151 -0.0746986 6.57129 -0.0746986 6.43098 0.224096L4.553 4.22544L0.361933 4.86563C0.0176943 4.91846 -0.119774 5.33711 0.121647 5.58422L3.16639 8.70508L2.44668 13.1171C2.3893 13.4676 2.76365 13.7306 3.07323 13.5585L6.81668 11.4897L10.5601 13.5591C10.8669 13.7295 11.2446 13.4716 11.1867 13.1177L10.467 8.70565L13.5117 5.58478C13.7531 5.33711 13.6151 4.91846 13.2714 4.86563Z" fill="#FFC107" />
    </svg>
  )
}
